import React from 'react'

import { Button, IconPlayDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { getPageSource, segment, track } from '@mc/track-event'
import { useStaticData } from '@mc/static-data-react'
import { usePrimaryCta } from '@mc/growth'

import CTA from 'components/CTA'

import { Camp } from 'pages/sessions/classes/[slug]/types'

type FooterCTAsProps = {
  title: string
  onTrailerClick: () => void
  pageType: string
  hasTrailer?: boolean
}

type Responsive = {
  ltLG: boolean
  ltSM: boolean
}

const FooterCTAsResponsive = ({
  title,
  onTrailerClick,
  pageType,
  hasTrailer = true,
  ltLG,
  ltSM,
}: FooterCTAsProps & Responsive) => {
  const { t } = useTranslation('@mc/next')
  const { ctaCopy, ctaHref } = usePrimaryCta()

  const { camp } = useStaticData<{ camp?: Camp }>()

  const trackPurchaseClicked = () => {
    track(segment.EventTypes.PURCHASE_CLICK, {
      category: 'footer-cta',
      location: 'body',
      action: ctaCopy,
      href: ctaHref,
      page_type: pageType,
      class_type: 'camp',
      class: camp?.slug ?? '',
      page_source: getPageSource(),
    })
  }

  return (
    <div
      className={`${
        !ltSM ? 'mc-px-8' : ''
      } d-flex flex-column align-items-center mc-py-10`}
    >
      <h2 className='mc-text-h1 mc-mb-9 mc-text--center'>{t(title)}</h2>
      <div className='d-flex flex-column flex-lg-row'>
        <CTA
          className='mc-mx-2'
          trackPurchaseClick={false}
          onClick={trackPurchaseClicked}
        />
        {hasTrailer && (
          <Button
            className={`mc-mx-2 ${ltLG ? 'mc-mt-4' : ''}`}
            kind='tertiary'
            onClick={onTrailerClick}
          >
            <IconPlayDefault className='mc-mr-2' />
            {t('sessions.footer.trailer')}
          </Button>
        )}
      </div>
    </div>
  )
}

export const FooterCTAs = (props: FooterCTAsProps) => (
  <>
    <div className='d-block d-sm-none'>
      <FooterCTAsResponsive {...props} ltLG ltSM />
    </div>
    <div className='d-none d-sm-block d-lg-none'>
      <FooterCTAsResponsive {...props} ltLG ltSM={false} />
    </div>
    <div className='d-none d-lg-block'>
      <FooterCTAsResponsive {...props} ltLG={false} ltSM={false} />
    </div>
  </>
)
